<template>
    <div class="mt-3 mb-2">
        <vtc-providers-filters></vtc-providers-filters>

        <v-data-table :headers="headers" :items="providers" class="border"
                      :options.sync="options"
                      no-data-text="Aucun prestataire"
                      show-select
                      v-model="selectedProvidersFromVtcList"
                      :footer-props="{
                                itemsPerPageAllText: 'Toutes',
                                itemsPerPageText: 'Prestataires par page',
                                itemsPerPageOptions: [10, 20, 50, 100]
                            }">

            <template v-slot:item.name="{ item }">
                <div v-if="item.name === null">
                    <router-link :to="'/summary/' + encodeUri(item.id)">-</router-link>
                </div>
                <div v-else>
                    <router-link :to="'/summary/' + encodeUri(item.id)">{{ item.name }}</router-link>
                </div>
            </template>

            <template v-slot:item.commune="{ item }">
                <span v-if="item.commune">
                    {{ item.commune.name }}
                </span>
            </template>

            <template v-slot:item.category="{ item }">
                {{ item.category.label }}
            </template>

            <template v-slot:item.business_status="{ item }">
                <div  v-if="item.source_google !== null && item.state === null ">
                    <div v-if="item.business_status === 'OPERATIONAL'">
                        <v-tooltip right>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon v-on="on">check_circle</v-icon>
                            </template>
                            <span>
                            Actif
                        </span>
                        </v-tooltip>
                    </div>
                    <div v-else-if="item.business_status === 'CLOSED_TEMPORARILY'">
                        <v-tooltip right>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon v-on="on">timelapse</v-icon>
                            </template>
                            <span>
                            Fermé temporairement
                        </span>
                        </v-tooltip>
                    </div>
                    <div v-else-if="item.business_status === 'CLOSED_PERMANENTLY'">
                        <v-tooltip right>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon color="error" v-on="on">cancel</v-icon>
                            </template>
                            <span>
                            Fermé définitivement
                        </span>
                        </v-tooltip>
                    </div>
                </div>
            </template>

            <template v-slot:item.status="{ item }">
                <div v-if="item.state !== null && item.state === 'NO_GOOGLE_SOURCE'">
                    Aucune source google satisfaisante
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn @click="prepareGoogleSourceChoice(item)" icon>
                                <v-icon color="primary" v-on="on">find_replace</v-icon>
                            </v-btn>
                        </template>
                        <span>
                            Refaire une recherche de page Google
                        </span>
                    </v-tooltip>
                </div>
                <div v-else-if="item.source_google === null">
                    <v-btn class="bg-warning text-white p-1" @click="prepareGoogleSourceChoice(item)">
                        <v-icon class="mr-2">search</v-icon>
                        Identifier
                    </v-btn>
                </div>
                <div v-else class="d-flex">
                    Suivi
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <a :href="item.source_google.url" target="_blank">
                                <v-icon right color="blue" v-on="on">link</v-icon>
                            </a>
                        </template>
                        <span>
                            Voir la page Google My Business
                        </span>
                    </v-tooltip>
                </div>
            </template>

            <template v-slot:item.actions="{ item }">
                <v-menu bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn icon v-on="on">
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>

                    <v-list>
                        <v-list-item @click="removeProvider(item)">
                            <v-list-item-title>
                                <v-icon color="error">delete</v-icon>
                                Retirer le prestataire de la veille
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item @click="openHistoryModal(item)">
                            <v-list-item-title>
                                <v-icon color="primary">history</v-icon>
                                Voir l'historique du prestataire
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item @click="prepareGoogleSourceChoice(item)"
                                     v-if="(item.state !== null && item.state === 'NO_GOOGLE_SOURCE') ||
                                     item.source_google !== null ">
                            <v-list-item-title>
                                <v-icon color="primary">find_replace</v-icon>
                                Refaire une recherche de page Google
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </template>
        </v-data-table>

        <v-dialog ref="dialog" v-model="selectGoogleSourceModal" persistent max-width="1200px" fullscreen
                  :retain-focus="false">
            <vtc-google-source-choice-modal ref="modale"
            ></vtc-google-source-choice-modal>
        </v-dialog>

        <v-dialog ref="dialog" v-model="historyModal" persistent width="800px">
            <vtc-diff-history ref="modale" :provider="selectedProvider"
            ></vtc-diff-history>
        </v-dialog>

        <confirm ref="confirm"></confirm>
    </div>
</template>

<script>
import { mapState, mapMutations } from "vuex"
import VtcGoogleSourceChoiceModal from "./VtcGoogleSourceChoiceModal.vue"
import VtcProvidersFilters from "./VtcProvidersFilters.vue"
import VtcDiffHistory from "./VtcDiffHistory.vue"
import Confirm from "../tools/Confirm.vue"

export default {
    name: "VtcProviders",
    components: { VtcGoogleSourceChoiceModal, VtcProvidersFilters, VtcDiffHistory, Confirm },
    data() {
        return {
            headers: [
                {
                    text: "Nom",
                    value: "name",
                },
                {
                    text: "Catégorie",
                    value: "category",
                },
                {
                    text: "Commune",
                    value: "commune",
                },
                {
                    text: "Destinataire",
                    value: "email",
                },
                {
                    text: "Statut d'ouverture",
                    value: "business_status",
                },
                {
                    text: "Etat",
                    value: "status",
                },
                {
                    text: "Actions",
                    value: "actions",
                },
            ],
            options: { itemsPerPage: 10, page: 1 },
            historyModal: false,
            selectedProvider: null,
        }
    },
    methods: {
        ...mapMutations("vtc", [
            "setVtc",
            "setProviderWithoutGoogleSource",
            "setSelectGoogleSourceModal",
        ]),
        encodeUri(id) {
            return btoa(id)
        },
        removeProvider(provider) {
            let payload = {
                vtcId: this.vtc.id,
                providerId: provider.id,
            }

            this.$refs.confirm.open("Attention",
              "Etes-vous sûr de vouloir retirer ce prestataire de la veille ?", { color: "red" }).then(
              (confirm) => {
                  if (confirm) {
                      this.$global.loading = true
                      this.$http.put("veille-tourisme/vtc/providers/remove", payload).then(res => {
                          this.$global.$emit("reload-providers")
                          this.setVtc(res.body.data.vtc)
                          this.$global.loading = false
                      })
                  }
              },
            )
        },
        prepareGoogleSourceChoice(provider) {
            this.setProviderWithoutGoogleSource(provider)
            this.setSelectGoogleSourceModal(true)
        },
        openHistoryModal(provider) {
            this.selectedProvider = provider
            this.historyModal = true
        },
    },
    computed: {
        ...mapState("vtc", [
            "vtc",
            "selectGoogleSourceModal",
            "providers",
        ]),
        ...mapState("vtcFilter", [
          "search",
            "selectedCategories",
            "selectedProviderStates",
            "selectedTags",
            "selectedCommunes",
            "selectedTourismSectors",
            "emailSearch",
            "selectedBusinessStatus",
          ],
        ),
        selectedProvidersFromVtcList: {
            get() {
                return this.$store.state.vtc.selectedProvidersFromVtcList
            },
            set(value) {
                this.$store.commit("vtc/setSelectedProvidersFromVtcList", value)
            },
        },
    },
    watch: {
        search() {
            this.options.page = 1
            this.$global.$emit("reload-providers")
        },
        selectedCategories() {
            this.options.page = 1
            this.$global.$emit("reload-providers")
        },
        selectedCommunes() {
            this.options.page = 1
            this.$global.$emit("reload-providers")
        },
        selectedProviderStates() {
            this.options.page = 1
            this.$global.$emit("reload-providers")
        },
        selectedBusinessStatus() {
            this.options.page = 1
            this.$global.$emit("reload-providers")
        }
    },
    created() {
        this.$global.$on("close-history-modal", () => {
            this.historyModal = false
            this.selectedProvider = null
        })
    },
    beforeDestroy() {
        this.$global.$off("close-history-modal")
    },
}
</script>